import React, { useMemo } from 'react';
import { SafeHTML } from '../common';

interface FeaturedProps {
  posts: string[];
  name?: string;
}

const Featured: React.FC<FeaturedProps> = React.memo(({ posts, name }) => {
  // Memoize the limited posts array to prevent unnecessary re-renders
  const limitedPosts = useMemo(() => posts.slice(0, 3), [posts]);

  // Memoize title visibility check
  const showTitle = useMemo(() => name && name !== '' && name !== 'null', [name]);

  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <div className="blog-index-featured">
      {showTitle && (
        <h4 className="blog-index-featured-title" color="secondary">
          {name}
        </h4>
      )}
      {limitedPosts.map((post, index) => (
        <SafeHTML key={index} html={post} className="featured" />
      ))}
    </div>
  );
});

export default Featured;
